import createReducer from '../../../../../util/createReducer';
import qs from 'querystring'
import * as http from '../../../../../util/http';
import {HANDLE_OPEN} from '../../../../../uis/tip/reduces'

export const SEND_PAY = 'SEND_PAY';

export const DEFAULT_SIZE = 10

const API_PREFIX = '/recharge'

const LIST_API = `${API_PREFIX}/list`

export const RECEIVE_BILL_LIST = `RECHARGE_RECEIVE_BILL_LIST`

export const CHANGE_PAGE = `RECHARGE_CHANGE_PAGE`

export const SHOW_MODAL = `RECHARGE_SHOW_MODAL`

export const HIDE_MODAL = `RECHARGE_HIDE_MODAL`

export const CHANGE_QUERY = `RECHARGE_CHANGE_QUERY`

export const CHANGE_SORT = `RECHARGE_CHANGE_SORT`

export const CHANGE_SEARCH_VALUE = `RECHARGE_CHANGE_SEARCH_VALUE`


function getBillData(params,dispatch) {
    return http.get(`${LIST_API}?${qs.stringify(params)}`)
        .then(data => {
            dispatch({
                type: RECEIVE_BILL_LIST,
                data: data.data
            })
        })
}
export function getBillList() {
    return (dispatch,getState) => {
        const {recharge:{page,query,search}} = getState()
        const data = {
            page: page.index,
            size: page.size
        }
        if (query.status !== '全部') {
            data['searchValue']  = query.status
        }
        if (search.value) {
            data['searchValue'] = search.value
        }
        return getBillData(data,dispatch)
    }
}
export function sendPay(body) {
    return (dispatch,getState) => {
        return http.post(`/recharge/add`,body)
            .then((data) => {
                dispatch({
                    type: SEND_PAY,
                    data:data.data
                });
            }).then(() => {
                dispatch({type: HANDLE_OPEN,variant: 'success',message: '充值完成，可在充值表中查看本次充值状态详情',time: 2000})
                dispatch({type: HIDE_MODAL})
                dispatch(getBillList())
            })
    }
}

const initialState = {
    list: [],
    page: {
        index: 0,
        size: DEFAULT_SIZE
    },
    total: 0,
    showModal: {
        rechargeModal: false
    },
    query: {
        status: '全部'
    },
    order: 'asc',
    orderBy: 'createTime',
    search: {
        key: 'searchValue',
        value: ''
    }
}
export default createReducer(initialState, {
    [RECEIVE_BILL_LIST]: (state,{data}) => {
        return {...state,...data}
    },
    [SEND_PAY]: (state, {data}) => {
        return {...state, ...data}
    },
    [CHANGE_PAGE]: (state, {page}) => {
        return {...state, page}
    },
    [SHOW_MODAL]: (state,{key}) => {
        return {...state,showModal: {...state.showModal,[key]: true}}
    },
    [HIDE_MODAL]: (state) => {
        return {...state,showModal: initialState.showModal}
    },
    [CHANGE_QUERY]: (state,{data}) => {
        return {...state,query: {...state.query,...data}}
    },
    [CHANGE_SORT]: (state,{key,value}) => {
        return {...state,[key]:value}
    },
    [CHANGE_SEARCH_VALUE]: (state,{value}) => {
        return {...state,search: {...state.search,value}}
    },
})



// WEBPACK FOOTER //
// ./src/pages/home/routes/recharge/reducers/list.js